import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { Box, Flex } from "rebass";
import { getLocalizedString } from "../../utils";
import AvailabilityOrder from "./AvailabilityOrder";
import { ToastMessage } from "./ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { yodaOrdersActions } from "../../logic/actions";
import { ColorTooltip } from "../common/ColorTooltip";
import { filter } from "lodash";
import OrderInfoRow from "./OrderInfoRow";

const OrderInfo = ({
  color,
  customer,
  id,
  totalQuantity,
  totalPrice,
  modelCode,
  forceColorInvisibility,
  catalogueItems,
  type,
  isLastAdded,
}) => {
  const [showAvailability, setShowAvailability] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState();
  const [colorCode, setColorCode] = useState();
  const [mModelCode, setMModelCode] = useState();
  const [editingMobile, setEditingMobile] = useState(null);
  const { hidePrice } = useSelector((state) => state.system);

  const { order, orderRowDetails } = useSelector((state) => state.yodaOrders);

  const dispatch = useDispatch();

  const toggleShowAvailability = (doorId) => {
    if (doorId === showAvailability) {
      setShowAvailability(null);
    } else setShowAvailability(doorId);
  };

  useEffect(() => {
    if (isLastAdded && order?.customData?.doors?.length) {
      toggleShowAvailability(order.customData.doors[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLastAdded, order]);

  return (
    <Flex width="100%" flexDirection="column">
      <ToastMessage
        message={deleteMessage}
        needConfirm={true}
        confirmFunction={(ev) => {
          dispatch(
            yodaOrdersActions.removeProduct(
              order.id,
              type,
              id,
              mModelCode,
              colorCode,
            ),
          );
          setDeleteMessage(null);
          setColorCode(null);
          setMModelCode(null);
          if (colorCode) {
            forceColorInvisibility(colorCode);
          }
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        cancelFunction={(ev) => {
          setDeleteMessage(null);
          setColorCode(null);
          setMModelCode(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        style={{ width: 600 }}
      />
      <Flex width="100%" justifyContent="end" mb="4px">
        <Box
          bg="#dedede"
          onClick={() => {
            setColorCode(color.code);
            setMModelCode(modelCode);
            setDeleteMessage(
              getLocalizedString("DELETEORDER_ITEM_MESSAGE") +
                modelCode +
                "(" +
                color.code +
                ") ?",
            );
          }}
        >
          <IoMdClose size="22px" />
        </Box>
      </Flex>
      <Flex style={{ gap: "2px" }}>
        <Flex
          width="33.3%"
          bg="#f3f3f3"
          alignItems="center"
          flexDirection="column"
          pt="8px"
        >
          <span
            style={{
              fontWeight: "bold",
              textAlign: "center",
              wordWrap: "break-word",
            }}
          >
            {color.colorDescription}
          </span>
          <ColorTooltip
            id={id}
            code={color.code}
            rgb={color.rgb}
            colorDescription={color.colorDescription}
            componentName={"orderDetailsGrillReorderAndSwap"}
            isOrderMobile
          />
        </Flex>
        <Flex width="66.6%" flexDirection="column" position="relative">
          {order?.customData?.doors?.map((doorId, i) => {
            const door = customer?.doors?.find?.((door) => door.id === doorId);
            let catalogId = catalogueItems?.[id]?.catalog.filter(
              (f) => f.colorCode == color.code,
            )[0].catalogId;
            let tmpArr = filter(
              orderRowDetails,
              (orderRow) =>
                orderRow.catalogId == catalogId &&
                door?.id == orderRow.customData.doorId &&
                orderRow?.customData?.typeId === type,
            );

            let quantity = 0;
            let price = 0;

            tmpArr.forEach((e) => {
              quantity += e.currentQuantity;
              price += e.price;
            });

            return (
              <React.Fragment key={`door-data-${color.code}-${i}`}>
                <OrderInfoRow
                  label={door?.code || ""}
                  doorId={door?.id}
                  {...{
                    quantity,
                    price,
                    showAvailability,
                    toggleShowAvailability,
                    editingMobile,
                  }}
                />
                {showAvailability === door?.id && (
                  <AvailabilityOrder
                    element={color}
                    doorId={door?.id}
                    {...{ id, type, editingMobile, setEditingMobile }}
                  />
                )}
              </React.Fragment>
            );
          })}
          <OrderInfoRow
            label={"TOT."}
            quantity={totalQuantity || 0}
            price={totalPrice}
            isTotal
            bg={"#f2f2f2"}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default OrderInfo;
